<template>
  <div style="height:100%;width:100%;" id="app">
    <router-view ref="routerView" class="router-content"></router-view>
  </div>
</template>

<script>
import callapp from 'callapp'

export default {
  beforeMount() {},
  mounted() {
    // 隐藏app关闭按钮
    callapp('uiCloseBtn', { hide: 'true' })
    this.showVows()
  },
  data() {
    return {
      cityId: 0,
    }
  },

  methods: {
    showVows() {
      var url = 'vows.html'
      location.assign(url)
    }
  }
}
</script>

<style>
.router-content {
  position: absolute;
  left: 0;
  top: 0;
}
</style>
